import { render } from "./App.vue?vue&type=template&id=0165732c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0165732c&lang=less"
/* custom blocks */
import block0 from "@/locales/Navigation.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuildhome%2Frepo%2Fsrc%2FApp.vue&lang=yml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__